
import { CityPageTemplate } from '@/components/seo/CityPageTemplate';
import { Plane, Building2, Truck } from 'lucide-react';

const DallasPage = () => {
  return (
    <CityPageTemplate
      city="Dallas"
      state="Texas"
      stateAbbr="TX"
      population="1.3 million+"
      majorIndustries={["financial services", "technology", "telecommunications", "transportation", "defense"]}
      businessChallenges={[
        "Rapid business growth and scaling challenges",
        "Competitive talent market in tech and finance",
        "Multi-location workforce management",
        "Complex benefit administration for large employers",
        "Defense contractor security requirements"
      ]}
      peoSolutions={[
        "Scalable HR solutions for rapid growth",
        "Competitive benefits for talent attraction",
        "Multi-state payroll and compliance management",
        "Enterprise-level HR technology platforms",
        "Security clearance and compliance support"
      ]}
      localBusinessTypes={[
        { name: "Financial Services", description: "Banking, insurance, investment firms" },
        { name: "Technology", description: "Software, telecom, data centers" },
        { name: "Transportation", description: "Airlines, logistics, freight" },
        { name: "Defense", description: "Contractors, aerospace, cybersecurity" }
      ]}
      metaDescription="Find the best PEOs in Dallas with The PEO App. Compare quotes from top Dallas Professional Employer Organizations offering comprehensive HR solutions for financial services, technology, and transportation companies."
      keyFeatures={[
        {
          icon: Building2,
          title: "Financial Services Focus",
          description: "Specialized HR solutions for Dallas's financial sector including compliance with banking regulations and fiduciary requirements."
        },
        {
          icon: Plane,
          title: "Transportation Hub",
          description: "Expert HR services for Dallas's transportation and logistics industry including DOT compliance and safety management."
        },
        {
          icon: Truck,
          title: "Multi-Location Support",
          description: "Comprehensive HR management for companies with operations across multiple states and locations."
        }
      ]}
    />
  );
};

export default DallasPage;
